<div class="result-entry-container">
  <dx-toolbar style='padding-left: 16px; padding-right: 16px;margin-bottom: 4px'>
    <dxi-item location='before'>
      <dx-check-box text="Filter by Pending" (onValueChanged)="changeCheckBoxValue($event)" [value]="showPendingResults"
                    [disabled]="orders.length === 0"></dx-check-box>
    </dxi-item>
    <dxi-item location='before'>
      <dx-check-box text="Filter by Client Access" (onValueChanged)="showOnlyWithClientAccess($event)" [value]="showOnlyWithAccess"
                    [disabled]="orders.length === 0"></dx-check-box>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        text="Mass results"
        hint="Mass results entry is available only when orders with the same test are selected."
        [disabled]="!isMassResultEnabled()"
        (onClick)="openDialog()"
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        text="Comments"
        [disabled]="selectedKeys.length === 0"
        (onClick)="openCommentsDialog()"
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        icon='clearformat'
        hint="Clear"
        (onClick)="clear()"
        [disabled]="!valid"
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        icon='print'
        hint="Results Report Preview"
        [disabled]="!valid"
        (onClick)="preview()"
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        icon='save'
        hint="Save results"
        [disabled]="!valid"
        (onClick)="save()"
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        icon='columnchooser'
        (onClick)='showColumnChooser()'
      ></dx-button>
    </dxi-item>
  </dx-toolbar>

  <dx-data-grid [dataSource]="gridData"
                [showRowLines]='true'
                [showBorders]='true'
                [allowColumnReordering]="true"
                [highlightChanges]='true'
                [repaintChangesOnly]='true'
                [hoverStateEnabled]='true'
                height='40vh'
                [wordWrapEnabled]='true'
                [filterSyncEnabled]='true'
                [selection]="{allowSelectAll: true, mode: 'multiple'}"
                [(selectedRowKeys)]="selectedKeys"
                (onSaving)="onSaving($event)"
                (onRowValidating)="onRowValidation($event)"
                (onCellClick)="cellFocused($event)"
                (onSaved)="onSaved()"
  >
    <dxo-scrolling mode='multiple'></dxo-scrolling>
    <dxo-pager
      [visible]='true'
      [allowedPageSizes]='[50, 100, 500]'
      [showInfo]='true'
      [showNavigationButtons]='true'
      [showPageSizeSelector]='true'
    ></dxo-pager>
    <dxo-paging [pageSize]="50"></dxo-paging>
    <dxo-filter-row [showOperationChooser]='true' [visible]='true'></dxo-filter-row>
    <dxo-filter-panel [visible]='true'></dxo-filter-panel>
    <dxo-sorting mode='multiple'></dxo-sorting>
    <dxo-header-filter [visible]='true'></dxo-header-filter>
    <dxo-editing
      mode="cell"
      [allowUpdating]="true"
    >
    </dxo-editing>
    <dxo-keyboard-navigation
      [editOnKeyPress]="true"
      [enterKeyAction]="'moveFocus'"
      [enterKeyDirection]="'column'">
    </dxo-keyboard-navigation>

    <dxi-column dataField='id' caption='Composed Id' dataType="string" [visible]="false" [allowFiltering]="false"
                [allowEditing]="false" [showInColumnChooser]="false"
                [allowHeaderFiltering]="false"></dxi-column>
    <dxi-column dataField='testName' caption='Test' dataType="string" [allowFiltering]="true" [allowEditing]="false"
                [allowHeaderFiltering]="true" cellTemplate="testNameCellTemplate"></dxi-column>
    <dxi-column dataField='result' caption='Result' dataType="string" [allowHeaderFiltering]="false"
                [allowFiltering]="false" [allowEditing]="true" editCellTemplate="editResultsCellTemplate">
      <dxi-validation-rule
        type="custom"
        [validationCallback]="validateItem"
      ></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField='flag' caption='Flag' dataType="string" [allowHeaderFiltering]="false" [allowEditing]="false"
                cellTemplate="flagCellTemplate"
                [allowFiltering]="false"></dxi-column>
    <dxi-column dataField='referenceRange' caption='Ref. Range' dataType="string" [allowHeaderFiltering]="false"
                [allowEditing]="false"
                [allowFiltering]="false"></dxi-column>


    <dxi-column dataField='unitOfMeasure' caption='Unit' dataType="string" [visible]="false" [allowFiltering]="true"
                [allowEditing]="false"
                [allowHeaderFiltering]="true"
                [showInColumnChooser]="true"></dxi-column>
    <dxi-column dataField='testCode' caption='Test Code' dataType="string" [visible]="false" [allowFiltering]="true"
                [allowEditing]="false"
                [allowHeaderFiltering]="true"
                [showInColumnChooser]="true"></dxi-column>
    <dxi-column dataField='orderCode' caption='Order Id' dataType="string" [visible]="false" [allowFiltering]="true"
                [allowEditing]="false"
                [sortOrder]="'desc'"
                [sortIndex]="1"
                [allowHeaderFiltering]="true"
                [showInColumnChooser]="true"></dxi-column>
    <dxi-column caption='Comments' dataType="string" [visible]="false" [allowEditing]="false" [allowFiltering]="false"
                cellTemplate="commentsCellTemplate" [allowHeaderFiltering]="false" [showInColumnChooser]="true"></dxi-column>

    <dxi-column dataField='sort' dataType="int" [visible]="false" [showInColumnChooser]="false" [sortOrder]="'asc'"
                [sortIndex]="2"></dxi-column>

    <dxi-column dataField='editable' dataType="boolean" [visible]="false" [showInColumnChooser]="false" ></dxi-column>

    <div *dxTemplate="let cellInfo of 'testNameCellTemplate'">
      <a *ngIf="!cellInfo.data.editable" title="Please note that you do not have permission to enter this result." class="tooltip" style="color: grey">{{cellInfo.data.testName}}</a>
      <span *ngIf="cellInfo.data.editable">{{cellInfo.data.testName}}</span>
    </div>

    <div *dxTemplate="let cellInfo of 'commentsCellTemplate'">
      <p [innerHTML]="sanitizeComments(cellInfo.data)"></p>
    </div>

    <div *dxTemplate="let cellInfo of 'flagCellTemplate'">
      <span [ngSwitch]="cellInfo.data.mode">
        <span *ngSwitchCase="1">{{calculateAlphaFlagAndReferenceRange(cellInfo.data)}}</span>
        <span *ngSwitchCase="2">{{calculateNumericFlag(cellInfo.data)}}</span>
        <span *ngSwitchCase="4">{{calculateTiterFlag(cellInfo.data)}}</span>
        <span *ngSwitchCase="5">{{calculateSpecificCutOffFlag(cellInfo.data)}}</span>
      </span>
    </div>

    <div *dxTemplate="let cellInfo of 'editResultsCellTemplate'">
      <span id="editor-container-{{cellInfo.data.id}}}" [ngSwitch]="cellInfo.data.mode">
        <span *ngSwitchCase="1">
          <dx-select-box
            [disabled]="!cellInfo.data?.editable"
            [(value)]="cellInfo.value"
            [showClearButton]="false"
            [items]="getAlphaResults(cellInfo.data?.testId)"
            (onKeyDown)="alphaControlKeyPressed($event, cellInfo)"
            (onValueChanged)="setEditedValue($event, cellInfo)"
          ></dx-select-box>
        </span>
        <span *ngSwitchCase="2">
          <dx-number-box
            [hint]="!cellInfo.data?.editable ? 'Please note that you do not have permission to enter this result' : ''"
            [disabled]="!cellInfo.data?.editable"
            [format]="format(cellInfo.data)"
            [(value)]="cellInfo.value"
            [showClearButton]="false"
            (onKeyDown)="numericControlEnterKey($event, cellInfo)"
            (onValueChanged)="setEditedValue($event, cellInfo)"
          ></dx-number-box>
        </span>
        <span *ngSwitchCase="3">
          <dx-text-box
            [hint]="!cellInfo.data?.editable ? 'Please note that you do not have permission to enter this result' : ''"
            [disabled]="!cellInfo.data?.editable"
            [(value)]="cellInfo.value"
            [showClearButton]="false"
            (onKeyDown)="numericControlEnterKey($event, cellInfo)"
            (onValueChanged)="setEditedValue($event, cellInfo)"
          >
          </dx-text-box>
        </span>
        <span *ngSwitchCase="4">
          <dx-text-box
            [hint]="!cellInfo.data?.editable ? 'Please note that you do not have permission to enter this result' : ''"
            [disabled]="!cellInfo.data?.editable"
            [(value)]="cellInfo.value"
            [showClearButton]="false"
            (onKeyDown)="numericControlEnterKey($event, cellInfo)"
            (onValueChanged)="setEditedValue($event, cellInfo)"
          >
          </dx-text-box>
        </span>
        <span *ngSwitchCase="5">
        <dx-number-box
          [hint]="!cellInfo.data?.editable ? 'Please note that you do not have permission to enter this result' : ''"
          [disabled]="!cellInfo.data?.editable"
          [format]="format(cellInfo.data)"
          [(value)]="cellInfo.value"
          [showClearButton]="false"
          (onKeyDown)="numericControlEnterKey($event, cellInfo)"
          (onValueChanged)="setEditedValue($event, cellInfo)"
        >
        </dx-number-box>
        </span>
      </span>
    </div>
  </dx-data-grid>

  <app-mass-result-entry-dialog [popupVisible]="isDialogVisible"
                                [test]="massResultTest()"
                                (closeEvent)="onDialogClose($event)"></app-mass-result-entry-dialog>
  <app-comments-dialog [popupVisible]="isCommentsDialogVisible" (closeEvent)="onCommentsDialogClose()" [control]="commentsControl" ></app-comments-dialog>
</div>
